import AddCard from "./components/modal/AddCard";
import CompleteProfile from "./components/modal/CompleteProfile";
import { closeModals } from "./features/users/usersSlice";
import { useAppDispatch, useAppSelector } from "./Hook";
import AddReviewPlatform from "./pages/reviews/components/AddReviewPlateform";

const GlobalModals = () => {
  const dispatch = useAppDispatch();
  const reviewModal = useAppSelector((state) => state.userSlice.reviewModal);
  const profileModal = useAppSelector((state) => state.userSlice.profileModal);
  const paymentModal = useAppSelector((state) => state.userSlice.paymentModal);

  const handleCloseModals = () => {
    dispatch(closeModals());
  };

  return (
    <>
      <AddReviewPlatform show={reviewModal} onHide={handleCloseModals} />
      <CompleteProfile show={profileModal} onHide={handleCloseModals} />
      <AddCard show={paymentModal} setShow={handleCloseModals} />
      {/* Add other modals here */}
    </>
  );
};

export default GlobalModals;
